<template>
  <transition name="slide-down">
    <div
      v-if="announcementStore.visible"
      class="fixed top-0 left-0 right-0 z-50 bg-primary text-white shadow-lg pt-safe"
    >
      <div class="p-4 flex items-start gap-3">
        <div class="flex-shrink-0 text-2xl">📣</div>
        <div class="flex-1 min-w-0">
          <p class="text-sm leading-relaxed">
            {{ announcementStore.announcement?.message }}
            <a
              v-if="announcementStore.announcement?.showStoreLink"
              href="#"
              class="underline font-bold whitespace-nowrap"
              @click.prevent="openStore"
            >
              {{ storeLinkLabel }}
            </a>
          </p>
        </div>
        <button
          @click="announcementStore.dismiss()"
          class="flex-shrink-0 text-white/80 hover:text-white"
          aria-label="關閉公告"
        >
          ✕
        </button>
      </div>
    </div>
  </transition>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { Capacitor } from '@capacitor/core'
import { useAnnouncementStore } from '../stores/useAnnouncementStore'

// 依平台導向對應商店。iOS 走 Apple App Store，Android 走 Google Play；
// 兩者是各自獨立的常數／分支，調整其中一個不會影響另一個（CLAUDE.md 平台相容性原則）。
const IOS_APP_STORE_URL = 'https://apps.apple.com/app/id6756783688'
const ANDROID_PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.igoout.babyvaccinehelper'

const announcementStore = useAnnouncementStore()

const storeLinkLabel = computed(() => announcementStore.announcement?.storeLinkLabel || '前往下載')

const openStore = () => {
  const platform = Capacitor.getPlatform()
  const url = platform === 'ios' ? IOS_APP_STORE_URL : ANDROID_PLAY_STORE_URL
  window.open(url, '_blank', 'noopener,noreferrer')
}
</script>

<style scoped>
.slide-down-enter-active,
.slide-down-leave-active {
  transition: all 0.3s ease;
}
.slide-down-enter-from,
.slide-down-leave-to {
  transform: translateY(-100%);
  opacity: 0;
}
</style>
